// Shared filter helpers for the category page and its filter panel.

// Empty filter state: the four built-in keys plus one array per admin-configured
// filter field on the open category (e.g. connectivity, usageType).
export const buildEmptyFilters = (filterFields = []) => ({
  availability: [],
  condition: [],
  brand: [],
  model: [],
  ...Object.fromEntries(filterFields.map((f) => [f.key, []])),
});
